import React, { useEffect, useState } from 'react';
import '../../commonComp/personalAndBank/personalandbank.scss';
import detailsEdit from '../../../../asset/images/ibaimages/detailsEdit.svg';
import { Button, Modal } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { handlePanInput, NameInput, NumberInput } from '../../../../CommonMethhods/CommonMethods';
import { toast } from 'react-toastify';

const PersonalAndBank = ({ selectedAgent }) => {
  const getRole = localStorage.getItem("IbaRole");
  const [filterModal, setFilterModal] = useState(false);
  const [agentData, setAgentData] = useState(selectedAgent);
  const schema = Yup.object().shape({
    fullName: Yup.string().required('Full name is required'),
    dob: Yup.date()
      .required('DOB is required')
      .max(
        new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
        'You must be at least 18 years old'
      ),
    gender: Yup.string().required('Gender is required'),
    pan: Yup.string()
      .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Invalid PAN format')
      .required('PAN is required'),
    aadhaar: Yup.string()
      .matches(/^\d{12}$/, 'Aadhaar must be exactly 12 digits')
      .required('Aadhaar is required'),
    address: Yup.string().required('Address is required'),
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  useEffect(() => {
    setAgentData(selectedAgent);
  }, [selectedAgent]);

  const openEditModal = () => {
    setFilterModal(true);

    const formatDOBForInput = (dobStr) => {
      if (!dobStr) return null;
      const [day, month, year] = dobStr.split('-');
      return `${year}-${month}-${day}`;
    };
    const today = new Date();
    const default18YearsAgo = new Date(today.setFullYear(today.getFullYear() - 18))
      .toISOString()
      .split('T')[0];

    reset({
      fullName: agentData?.name || '',
      dob: agentData?.dob || default18YearsAgo,
      gender: agentData?.gender || '',
      pan: agentData?.pan || '',
      aadhaar: agentData?.aadhaar || '',
      address: agentData?.address || '',
    });
  };

  // const onSubmit = async (data) => {
  //   const formattedDob = new Date(data.dob).toISOString().split('T')[0];
  //   const payload = {
  //     name: data.fullName,
  //     dob: formattedDob,
  //     gender: data.gender,
  //     pan: data.pan,
  //     aadhaar: data.aadhaar,
  //     address: data.address,
  //   };

  //   const url = `https://uat-cosmos.bajajfinservsecurities.in/iba/api/v1/admin/agents/${selectedAgent.id}/personal_details`; // Assuming selectedAgent has an 'id'

  //   try {
  //     const response = await fetch(url, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/json',
  //         reserv: 0,
  //         Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
  //       },
  //       body: JSON.stringify(payload),
  //     });
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! status: ${response.status}`);
  //     }

  //     const result = await response.json();
  //     console.log(result.status, "result");
  //     if (result.status == 0) {
  //       toast.success(result.message);
  //       if (result?.data) {
  //         setAgentData(result.data);
  //       }
  //       setFilterModal(false);
  //     }else{
        
  //       // toast.error(message)
  //     }

  //   } catch (error) {
  //     console.error('❌ Error updating personal details:', error);
  //   }
  // };
  
 const formatDate = (isoDate) => {
  const date = new Date(isoDate);

  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${month}-${day}-${year}`;
};
  

  return (
    <>
      <div className="personal-details-card">
        <div className="card-head">
          <div className="card-header">Personal Details</div>
          {/* <img style={{cursor:"pointer"}} src={detailsEdit} alt="detailsEdit" onClick={openEditModal} /> */}
        </div>

        <div className="detail-row">
          <span className="label">Full Name:</span>
          <span className="value">{selectedAgent?.Personal?.AgentName || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">DOB:</span>
          <span className="value">{(selectedAgent?.Personal?.DOB) ? formatDate(selectedAgent?.Personal?.DOB) : '-'}</span>
        </div>
        {getRole === "IBA Admin" ?
        <div className="detail-row">
          <span className="label">Gender:</span>
          <span className="value">{selectedAgent?.Personal?.Gender || '-'}</span>
        </div>
        : getRole === "IBA" &&
        <div className="detail-row">
          <span className="label">Email-ID:</span>
          <span className="value">{selectedAgent?.Personal?.email || '-'}</span>
        </div>
        }

        {getRole === "IBA Admin" ?
        <div className="detail-row">
          <span className="label">Address:</span>
          <span className="value">{selectedAgent?.Personal?.Address || '-'}</span>
        </div>
        : getRole === "IBA Admin" &&
        <div className="detail-row">
          <span className="label">DOJ:</span>
          <span className="value">{selectedAgent?.Personal?.Address || '-'}</span>
        </div>
        }
        
        <div className="detail-row">
          <span className="label">Aadhaar:</span>
          <span className="value">{selectedAgent?.Personal?.Aadhar || '-'}</span>
        </div>
        <div className="detail-row">
          <span className="label">PAN:</span>
          <span className="value">{selectedAgent?.Personal?.PAN || '-'}</span>
        </div>
      </div>

      {/* <Modal
        show={filterModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setFilterModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="profile-modal-content">
            <div className="iput-wrapp">
              <div className="profile-header">Personal Details</div>

              <div className="profile-form-row">
                <div className="form-group">
                  <label>Full Name:</label>
                  <input onInput={NameInput} {...register('fullName')} type="text" />
                  {errors.fullName && <p className="error">{errors.fullName.message}</p>}
                </div>

                <div className="form-group">
                  <label>DOB:</label>
                  <input type="date" {...register('dob')} />
                  {errors.dob && <p className="error">{errors.dob.message}</p>}
                </div>
              </div>

              <div className="profile-form-row">
                <div className="form-group">
                  <label>Gender:</label>
                  <select className="gender-select-iba" {...register('gender')}>
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  {errors.gender && <p className="error">{errors.gender.message}</p>}
                </div>

                <div className="form-group">
                  <label>PAN:</label>
                  <input onInput={(e) => handlePanInput(e)} {...register('pan')} type="text" />
                  {errors.pan && <p className="error">{errors.pan.message}</p>}
                </div>
              </div>

              <div className="profile-form-row">
                <div className="form-group">
                  <label>Aadhaar:</label>
                  <input onInput={NumberInput} {...register('aadhaar')} maxLength={12} type="text" />
                  {errors.aadhaar && <p className="error">{errors.aadhaar.message}</p>}
                </div>

                <div className="form-group">
                  <label>Address:</label>
                  <textarea  {...register('address')} rows="3" />
                  {errors.address && <p className="error">{errors.address.message}</p>}
                </div>
              </div>
            </div>

            <div className="profile-footer-iba">
              <Button
                className="cancel-btn-iba"
                onClick={() => setFilterModal(false)}
              >
                Cancel
              </Button>
              <Button type="submit" className="save-btn-iba">Save</Button>
            </div>
          </form>
        </Modal.Body>
      </Modal> */}
    </>
  );
};

export default PersonalAndBank;